var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6875 21.375H28.375V26.6875H33.6875V21.375Z",
    fill: "#9CDBAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83 21H35V27H83V21Z",
    fill: "#F6F6F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83 55H29V58H83V55Z",
    fill: "#F6F6F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5625 61.375H29V64.5625H72.5625V61.375Z",
    fill: "#F6F6F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1875 67.75H29V70.9375H49.1875V67.75Z",
    fill: "#F6F6F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74.375H29V77.375H65V74.375Z",
    fill: "#F6F6F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73 80.375H29V83.375H73V80.375Z",
    fill: "#F6F6F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83 88H29V91H83V88Z",
    fill: "#F6F6F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 19.25C22 16.9028 23.9028 15 26.25 15H85.75C88.0972 15 90 16.9028 90 19.25V93.625C90 95.9722 88.0972 97.875 85.75 97.875H26.25C23.9028 97.875 22 95.9722 22 93.625V19.25ZM26.25 17.125C25.0764 17.125 24.125 18.0764 24.125 19.25V93.625C24.125 94.7986 25.0764 95.75 26.25 95.75H85.75C86.9236 95.75 87.875 94.7986 87.875 93.625V19.25C87.875 18.0764 86.9236 17.125 85.75 17.125H26.25Z",
    fill: "#4DC370"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9438 30H30.0562C29.4729 30 29 30.5779 29 31.2909V50.7091C29 51.4221 29.4729 52 30.0562 52H81.9438C82.5271 52 83 51.4221 83 50.7091V31.2909C83 30.5779 82.5271 30 81.9438 30Z",
    fill: "#F1F1F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoc);
export default __webpack_public_path__ + "static/media/ic_doc.72f2bce270bce29c5c9c4b612ac5449c.svg";
export { ForwardRef as ReactComponent };